<template>
  <div class="nsale_ myPage_ poster_">
    <div class="list_">
      <!-- <div class="poster_outer">
        <img
          style="height: 100%; width: 100%"
          v-if="step == '2'"
          class="poster_img"
          :src="uploadImg"
          alt="posterImg"
        />
        <div v-if="step == '2'" class="saveTip">
          <span>长按可保存海报</span>
        </div>
      </div> -->
      <!-- 预览 -->
      <cube-slide
        :allowVertical="true"
        :initialIndex="currentIndex"
        @change="handleSlideChange"
        :autoPlay="false"
        :loop="false"
				:showDots="items.length > 1"
        :data="items"
      >
        <cube-slide-item
          v-for="(item, index) in items"
          :key="index"
          :style="{ padding: smallEidth ? '0 10px 0 19px' : '0 19px' }"
        >
          <div class="item_ poster_item_" :class="'posterHtml' + index">
            <div v-if="!posterImages[index]">
              <div class="item_1">
                <img class="item_1img" :src="item.img" alt="poster" />
              </div>
              <div class="item_2">
                <img class="item_2img" :src="item.photo || photo" alt="code" />
                <div class="text_content" v-if="step == '3'">
                  <cube-input
                    class="inputStyle"
                    v-model="userInfo.name"
                    placeholder="请输入您的姓名"
                  ></cube-input>
                  <cube-textarea
                    v-if="userInfo.isYuTaiMall != '1'"
                    :maxlength="30"
                    :indicator="false"
                    v-model="userInfo.desc"
                    placeholder="请输入您想说的话（30字以内）"
                  ></cube-textarea>
                  <cube-textarea
                    v-else
                    :maxlength="30"
                    :indicator="false"
                    v-model="userInfo.officePhone"
                    placeholder="请输入联系电话"
                  ></cube-textarea>
                </div>
                <div class="text_content" v-else>
                  <div class="txt txt1">{{ userInfo.name }}</div>
                  <div class="txt txt2" v-if="userInfo.isYuTaiMall != '1'">
                    {{ userInfo.desc }}
                  </div>
                  <div class="txt txt2" v-if="userInfo.isYuTaiMall == '1'">
                    联系电话：{{ userInfo.officePhone }}
                  </div>
                  <div class="txt txt2" v-if="userInfo.isYuTaiMall == '1'">
                    所属机构：{{ userInfo.company }}
                  </div>
                  <div class="txt txt2" v-if="userInfo.isYuTaiMall == '1'">
                    执业证号：{{ userInfo.vocationalCertificate }}
                  </div>
                </div>
                <img class="qrcode_" :src="item.qrcode" alt="qrcode" />
              </div>
            </div>
            <div v-else>
              <img class="preview_poster_" :src="posterImages[index]" />
            </div>
          </div>
        </cube-slide-item>
      </cube-slide>
    </div>
    <div v-if="items.length > 0" class="btns">
      <div
        v-if="isShowHS == '1'"
        class="btn_ghost_s"
        @click="handleShowLeftSelect"
      >
        <i class="i_icon_"></i>
        推广话术
      </div>
      <cube-button
        v-if="step == '3'"
        class="btn_ btn_ghost_"
        @click="handleSave"
        >完成</cube-button
      >
      <cube-button v-else class="btn_ btn_ghost_" ghost @click="handleEdit"
        >编辑海报</cube-button
      >
      <cube-button class="btn_" @click="handleShare">立即分享</cube-button>
    </div>
    <div ref="left_select_" @click="handleHideSelect" class="left_select_">
      <div class="content_">
        <ul>
          <li
            @click.stop="sloganIndex = index"
            :key="index"
            v-for="(item, index) in slogans"
            :class="{ active_: sloganIndex == index }"
          >
            {{ item }}
          </li>
        </ul>
        <div>
          <cube-button @click="handleCopy" class="btn_copy_"
            >一键复制</cube-button
          >
        </div>
      </div>
    </div>
    <div
      @click="showOverlay = false"
      :class="{ show_: showOverlay }"
      class="share_overlay_"
    >
      <img src="../../../assets/image/bs-2.0/2.png" />
    </div>

    <div class="outer_" v-if="showLoading">
      <cube-loading :size="28"></cube-loading>
    </div>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import api from "@/utils/api";

export default {
  data() {
    return {
      smallEidth: false,
      inviteUrl: "",
      showLoading: false,
      codeUrl: "",
      tempId: "",
      photo: require("../../../assets/image/bs-2.0/3.png"),
      userInfo: {
        name: "",
        desc: "",
        officePhone: "",
        company: "",
        vocationalCertificate: "",
        isYuTaiMall: null,
      },
      iosFirst: true, //ios系统生成海报偏移问题：ios第一次生成
      uploadImg: "", //上传后的链接地址
      posterImg: "", // 最终生成的海报图片
      preview: true,
      step: "1",
      items: [],
      slogans: [],
      currentIndex: 0, // 当前选中的海报索引
      sloganIndex: 0,
      showBobble: true,
      showOverlay: false,
      posterImages: {}, // 已经生成好的海报
      info: {},
      isShowHS: "", //0 不展示  1展示
    };
  },
  mounted() {
    let { isShowHS } = this.$route.query;
    this.isShowHS = isShowHS;
    this.jadgeMobileWidth();
    this.currentIndex = 0;
    this.showOptionMenu();

    this.fetchData();
    this.queryProduct().then(() => {
      this.fetchJsSdkSign();
    });
    let scrollY = 0;
    // window.onscroll = () => {
    //   console.log(111,scrollY,window.scrollY)
    //   if (scrollY > window.scrollY) {
    //     this.showBobble = true;
    //   } else {
    //     this.showBobble = false;
    //   }
    //   scrollY = window.scrollY;
    // };
  },
  beforeRouteEnter(to, from, next) {
    console.log("beforeRouteEnter -->", to, from);
    next();
  },
  activated() {
    console.log("activated -> ", 1, this.$route);
  },
  methods: {
    jadgeMobileWidth() {
      console.log(screen.width);
      if (screen.width <= 320) {
        this.smallEidth = true;
      }
    },
    showOptionMenu() {
      try {
        WeixinJSBridge.call("showOptionMenu");
      } catch (error) {}
    },
    handleShare() {
      this.showOverlay = true;
    },
    fetchJsSdkSign() {
      // const url = encodeURIComponent(location.href.split("#")[0]);
      let url = location.href.split("#")[0];
      let _this = this;
      console.log(this.transformUrl(this.info.productPicuter), "___>");
      api
        .getJsJdkSign2({
          url: url,
          userId: this.$route.query.userid,
        })
        .then((res) => res.data)
        .then(async (data) => {
          const { appId, jssdkReqData } = data;
          console.log(appId, jssdkReqData);
          let options = {
            // debug: true,
            appId: appId, // 必填，公众号的唯一标识
            timestamp: jssdkReqData.timestamp, // 必填，生成签名的时间戳
            nonceStr: jssdkReqData.noncestr, // 必填，生成签名的随机串
            signature: jssdkReqData.signature, // 必填，签名，见附录1
            jsApiList: ["updateTimelineShareData", "updateAppMessageShareData"]
          };
          const { wxShare } = await this.$wx.wxConfig(options)
          let opstion = {
            title: _this.info.productName, // 分享标题
            link: window.location.href,
            imgUrl: _this.info.productPicuter, // 分享图标
            desc: "点击查看产品海报",
            success: function () {
              console.log("success++");
            },
            error: function () {
              console.log("failed++");
            },
          };
          wxShare(opstion)
        });
    },
    handleCopy() {
      // import("clipboard-copy").then(copy => {
      //   const content = this.slogans[this.sloganIndex];
      //   console.log(content,"-->",copy)
      //   copy.default(content).then(s => {
      //     console.log(s,"-->s")
      //     window.$toast("复制成功！");
      //   })
      // });
      const content = this.slogans[this.sloganIndex];
      this.$copyText(content).then(
        (e) => {
          window.$toast("复制成功");
        },
        (e) => {
          window.$toast("复制失败");
        }
      );
    },
    queryProduct() {
      let data = {
        userId: this.$route.query.userid,
        productCode: this.$route.query.code,
        mainId: this.$route.query.mainId,
      };
      return api
        .queryProduct(data)
        .then((res) => res.data)
        .then((data) => {
          this.info = data.content.productDetail;
        });
    },
    fetchData() {
      api
        .getPromotionPoster({
          mainId: this.$route.query.mainId || 1048,
          productCode: this.$route.query.code || 2810,
          userid: this.$route.query.userid,
        })
        .then((res) => res.data)
        .then((data) => {
          const {
            posterUrls,
            slogans,
            qrCodeUrl,
            headPortrait,
            erpCertificates,
          } = data.content;
          // 用户信息
          for (let key in this.userInfo) {
            if (key === "desc") {
              this.userInfo[key] = data.content.contactPhone;
            } else {
              this.userInfo[key] = data.content[key] || this.userInfo[key];
            }
          }
          let company = erpCertificates && erpCertificates.company;
          this.userInfo.company = company;
          let vocationalCertificate =
            erpCertificates && erpCertificates.vocationalCertificate;
          this.userInfo.company = vocationalCertificate;
          let officePhone = erpCertificates && erpCertificates.officePhone;
          this.userInfo.company = officePhone;
          this.items = posterUrls.map((item) => {
            return {
              // img: require('./1603962731163.jpg'),
              // // qrcode:'http://mall.run4wd.com/core/core/1611142951876.jpg',
              // qrcode:require('./1611207699221.jpg'),
              // photo: 'http://mall.run4wd.com/core/personalData/1600052394564.png',
              img: this.transformUrl(item),
              qrcode: this.transformUrl(qrCodeUrl), //TODO:http://mall.run4wd.com/core/core/1610969513026.jpg路径可能存在错误
              photo: this.transformUrl(headPortrait),
            };
          });
          this.slogans = slogans;
          console.log(this.items, "-->items列表");

          if (posterUrls.length == 0) {
            window.$toast("暂无海报");
          } else {
            // 开始画海报
            this.$nextTick(() => {
              this.startDrawToImage();
            });
          }
        });
    },
    handleSlideChange(index) {
      this.currentIndex = index;
      if (!index) {
        this.items = [...this.items];
      }
      // 切换选项时开始生成海报
      if (!this.posterImages[index]) {
        this.$nextTick(() => {
          this.startDrawToImage();
        });
      }
    },
    handleShowLeftSelect() {
      this.$refs["left_select_"].style.left = "0px";
    },
    handleHideSelect(e) {
      console.log("e -> ", e);
      this.$refs["left_select_"].style.left = "1000px";
    },
    hideOptionMenu() {
      try {
        WeixinJSBridge.call("hideOptionMenu");
      } catch (error) {}
    },
    getRegisterLink() {
      return api
        .getRegisterLink(this.tempId)
        .then((res) => res.data)
        .then((data) => {
          return data.content;
        })
        .then((url) => {
          this.inviteUrl = url;
          import("jr-qrcode").then((jrQrcode) => {
            // 模块方法调用，传入字符串，获取 base64 编码的图片 URL
            var imgBase64 = jrQrcode.getQrBase64(url);
            this.codeUrl = imgBase64;
          });
        });
    },
    startDrawToImage() {
      this.showLoading = true;
      window.$toast("准备生成分享海报，请稍后");
      window.scrollTo(0, 0);
      this.$nextTick(() => {
        this.createPoster();
      })
    },
    base64Save(data) {
      window.$toast("生成分享海报完成，长按图片下载");
      this.posterImages[this.currentIndex] = data.base64Img;
      // api.base64Bs(data).then(res => {
      //   this.uploadImg = res.data.content;
      // });
      this.showLoading = false;
    },
    AndroisIos() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        return true;
      } else if (isIOS) {
        return false;
      }
    },
    transformUrl(url) {
      if (!url) {
        return;
      }
      const transUrl = url;
      if (transUrl.indexOf("http") == -1) {
        url = "http://image.ssish.com/" + transUrl;
      }
      const pathname = new URL(url).pathname;
      let origin = window.location.origin;
      // 解决本地开发域名问题
      if (origin.indexOf("localhost") > -1 || origin.indexOf("192") > -1) {
        origin = "https://test-ssish.oss-cn-hangzhou.aliyuncs.com/";
      }
      const imgUrl = origin + pathname; // 转化后跨域的图片路径
      console.log(imgUrl, "==>imgUrl");
      return imgUrl; //;
    },
    createPoster() {
      // 生成海报
      let isAndroid = this.AndroisIos();
      let xNum = 0;
      if (isAndroid) {
        xNum = 15;
      } else if (this.iosFirst && !isAndroid) {
        xNum = 16;
      } else if (!this.iosFirst && !isAndroid) {
        xNum = 1;
      }
      const elId = ".posterHtml" + this.currentIndex;
      const vm = this;
      let domObj = document.querySelector(elId);
      html2canvas(domObj, {
        useCORS: true,
        allowTaint: true,
        backgroundColor: null,
        scrollX: 0,
        scrollY: 0,
        width: domObj.offsetWidth, // 下面解决当页面滚动之后生成图片出现白边问题
        height: domObj.offsetHeight - 3,
        dpi: window.devicePixelRatio * 2, // 解决图片不清晰问题
        scale: 2,
        logging: true,
        // foreignObjectRendering: true,
      }).then(function (canvas) {
        // 在微信里,可长按保存或转发
        vm.posterImg = canvas.toDataURL("image/jpg");
        let data = { base64Img: vm.posterImg };
        vm.base64Save(data);
      });
    },
    handleSave() {
      this.iosFirst = false;
      this.step = "1";
      this.$nextTick(() => {
        this.startDrawToImage();
      });
    },
    handleEdit() {
      this.step = "3";
      this.posterImages = {};
    },
  },
};
</script>

<style>
/* swipe样式覆盖 */
.poster_ .cube-slide-dots{
	top: 20px;
  left: 50%;
	bottom: auto;
	width: 340px;
	display: flex;
  padding: 0;
  transform: translate(-50%, -50%);
}
.poster_ .cube-slide-dots > span{
  display: inline-block;
  height: 4px;
	background: rgba(255, 255, 255, 0.4);
	flex: 1;
	margin: 0 4px;
	border-radius: 2px;
}
.poster_ .cube-slide-dots>span.active{
	background: #fff;
	flex: 1;
	margin: 0 4px;
	border-radius: 2px;
}
</style>

<style scoped lang="scss">
.nsale_ {
  background: #ffffff;
  min-height: 100vh;
	padding-bottom: 65px;
  .test_ {
    position: fixed;
    top: 20px;
    left: 0;
  }
  .preview_poster_ {
    width: 100%;
    height: auto;
  }
  .share_overlay_ {
    background: rgba(0, 0, 0, 0.7);
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: none;
    &.show_ {
      display: block;
    }

    img {
      display: block;
      width: 80%;
      height: auto;
      margin: 19px auto 0;
    }
  }
  .i_icon_ {
    margin: 0 auto;
    margin-bottom: 4px;
    display: block;
    width: 20px;
    height: 20px;
    background: url("../../../assets/image/bs-2.0/tghs.png") no-repeat;
    background-size: 100% auto;
  }
  .left_select_ {
    position: fixed;
    left: 1000px;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.1);
    // transition: all 0.5s ease-in-out;
    .content_ {
      height: 100%;
      padding: 40px 22px 24px;
      background: #fff;
      margin-left: 65px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      li {
        padding: 19px 15px 16px;
        margin-bottom: 15px;
        border: 1px solid #f8f8f8;
        background: #f8f8f8;
        font-size: 13px;
        border-radius: 13px 13px 0px 13px;
        text-align: left;
        line-height: 19px;
        &.active_ {
          border-radius: 13px 13px 0px 13px;
          border: 1px solid rgba(255, 124, 109, 1);
        }
      }
      .btn_copy_ {
        width: 266px;
        height: 45px;
        background: linear-gradient(
          45deg,
          rgba(255, 124, 108, 1) 0%,
          rgba(255, 162, 151, 1) 100%
        );
        border-radius: 7px;
      }
    }
  }
  .float_ {
    width: 32px;
    height: 73px;
    padding: 11px 0;
    background: linear-gradient(
      45deg,
      rgba(255, 124, 108, 1) 0%,
      rgba(255, 162, 151, 1) 100%
    );
    border-radius: 5px 0px 0px 5px;
    position: fixed;
    right: 0;
    bottom: 0;
    font-size: 11px;
    color: #fff;
    transition: right 0.3s ease-in-out;
    &.right_out_ {
      right: -100px;
    }
  }
  .poster_item_ {
    margin-bottom: 20px;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 1px 1px 6px 2px rgba(0, 0, 0, 0.1);
  }
	.btns {
		position: fixed;
		bottom: 0;
		width: 100%;
    background: #fff;
	}
  .btn_ghost_s {
    position: relative;
    display: inline-block;
    width: 60px;
    top: 10px;
    left: -5px;
    height: 45px;
    background: #fff;
    color: #333333;
    font-size: 9px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
  }
  .btn_ {
    display: inline-block;
    width: 136px;
    height: 45px;
    margin: 10px auto;
    background: linear-gradient(
      45deg,
      rgba(255, 124, 108, 1) 0%,
      rgba(255, 162, 151, 1) 100%
    );
    border-radius: 7px;
    padding: 0rem 0.426667rem 0rem;
    &.btn_ghost_ {
      width: 136px;
      border-radius: 7px;
      border: 1px solid rgba(255, 124, 109, 1);
      background: #fff;
      color: #ff7c6d;
      margin-right: 10px;
    }
  }
  .list_ {
    // margin: 0 0 20px 20px;
    padding-top: 10px;
    .item_ {
      .item_1 {
        height: 509px;
        position: relative;
        .item_1img {
          width: 100%;
          height: 100%;
        }
      }
      .item_2 {
        background: url("../../../assets/image/bs-2.0/botBack.png") no-repeat;
        background-size: 100% 100%;
        height: 115px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        font-size: 12px;
        color: rgba(102, 102, 102, 1);
        padding: 20px 0;
        box-shadow: 1px 1px 6px 1px rgba(0, 0, 0, 0.1);
        .item_2img {
          width: 70px;
          height: 70px;
          border-radius: 0.2rem;
          margin-left: 20px;
        }
        .text_content {
          flex: 1;
          max-width: calc(100% - 195px);
          margin-left: 10px;
        }
        .txt {
          text-align: left;
          white-space: break-spaces;
          word-break: break-all;
        }
        .txt1 {
          margin-bottom: 5px;
          font-weight: bold;
          font-size: 18px;
          color: #333333;
        }
        .txt2 {
          text-align: justify;
          color: #666666;
          font-size: 10px;
          font-weight: bold;
          white-space: initial;
        }
        .qrcode_ {
          width: 85px;
          height: 83px;
          margin-right: 10px;
        }
      }
    }
  }

  .poster_outer {
    position: relative;
    box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.08);
    border-radius: 30px;
    overflow: hidden;

    .saveTip {
      position: absolute;
      left: 0;
      bottom: 120px;
      width: 345px;
      font-size: 11px;
      height: 25px;
      line-height: 25px;
      background: rgba(0, 0, 0, 1);
      opacity: 0.4;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        color: rgba(255, 255, 255, 1);
        opacity: 0.5;
      }
    }
  }

  .saveTip {
    width: 345px;
    font-size: 11px;
    height: 25px;
    line-height: 25px;
    background: rgba(0, 0, 0, 1);
    opacity: 0.4;
    position: absolute;
    bottom: 140px;
    left: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      color: rgba(255, 255, 255, 1);
      opacity: 0.5;
    }
  }
}

.outer_ {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
